import * as utils from "./utils";
import * as $ from 'jquery';
import {sendAppEvent} from './tracking/app-events';

// Domain Events
import { UserFollowEvent } from './Shared/events';

$(document).on('submit', '.js-btn-follow', function(e){
    e.preventDefault();

    if(utils.redirectAnonymous()){
        return;
    }
    const follow = parseInt($(this).find('[name="following"]').val()) < 1,
        url = $(this).attr('action');


    let flowValue = utils.getFlow();

    $.ajax({
        url: url,
        type: !url.includes("/ajax/") && !follow ? 'delete' : 'post',
        data: $(this).serialize(),
        success: (response)=> {
            if(response.success || response.result) {

                const userFollowDataEvent = {
                    followed_user_id: this.querySelector('input[name="userFollowed"]').value,
                    action: (follow ? 'follow' : 'unfollow'),
                    flow: flowValue,
                    countrySeller: getCountrySeller(this.querySelector('input[name="userFollowed"]'))
                }
                const userFollowEvent = new UserFollowEvent(utils.config.user.id, ...Object.values(userFollowDataEvent));
                document.dispatchEvent(userFollowEvent);

                sendAppEvent('user_follow', { ...userFollowDataEvent });

                $(this).find('button.follow').toggleClass('d-none', follow);
                $(this).find('button.unfollow').toggleClass('d-none', !follow);
                $(this).find('input[name="following"]').val(follow? 1 : 0);

                $('#profileFollowingPush').toggleClass('d-none', !follow);
                $('#profileFollowingPush input').prop("checked", follow);

            }  else if (response.message) {
                utils.defaultAlertModal(response.message);
            }
        },
        error: () => utils.defaultAlertModal('Ha ocurrido un error')
    });
});

const getCountrySeller = (input) => {
    const productSheet = document.getElementById('product-sheet');
    if (productSheet) {
        return productSheet.dataset.biCountrySeller
    }
    if (input && input.dataset.biCountrySeller) {
        return input.dataset.biCountrySeller;
    }
    return '';
};